module.exports = __webpack_public_path__ + "img/0027.3749f20a.jpg";